import ordersDineIn from "@/services/orders.dine-in";
import notification from "@/services/notification";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    dine_in_orders: [],
    pagination: {},
    dine_in_order_details: null
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    setDineInOrders(state, data) {
      state.dine_in_orders = data;
    },
    setPagination(state, value) {
      state.pagination = value;
    },
    setOrderDineInDetails(state, details) {
      state.dine_in_order_details = details;
    }
  },
  actions: {
    async getOrdersDineInList({ commit }, payload) {
      commit("setLoading", true);
      commit("setErrors", null);
      commit("setDineInOrders", []);
      try {
        const { data, prev_page, max_page } = await ordersDineIn.getOrdersDineInList(payload);
        commit("setDineInOrders", data);
        commit("setPagination", {
          currentPage: payload.page,
          previousPage: prev_page,
          maxPage: max_page,
        });
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("setLoading", false);
      }
    },
    async getOrderDineInDetails({ commit }, uuid) {
      commit("setLoading", true);
      commit("setErrors", null);
      commit("setOrderDineInDetails", null);
      try {
        const { data } = await ordersDineIn.getOrderDineInDetails(uuid);
        commit("setOrderDineInDetails", data);
      } catch ({ errors }) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("setLoading", false);
      }
    }
  }
}